import React, { useMemo } from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeSection } from './ResumeSection';

interface Props {
  certifications: BuiltResume['certifications'];
}

function groupByYear(certs: BuiltResume['certifications']) {
  const groups = new Map<string, BuiltResume['certifications']>();

  for (const cert of certs) {
    const year = cert.date?.slice(0, 4) || 'Other';
    const existing = groups.get(year) || [];
    existing.push(cert);
    groups.set(year, existing);
  }

  return Array.from(groups.entries()).sort(([a], [b]) => Number(b) - Number(a));
}

export function CertificationSection({ certifications }: Props) {
  const grouped = useMemo(() => groupByYear(certifications), [certifications]);

  if (!certifications.length) return null;

  return (
    <ResumeSection title="Professional Development & Certifications">
      {grouped.map(([year, items]) => (
        <div key={year} className="resume-cert-year-group">
          <p className="resume-cert-year">{year}</p>
          {items.map((cert) => (
            <div key={`${cert.name}-${cert.issuer}`} className="resume-cert-item">
              <h3 className="resume-cert-name">
                {cert.name}
                {cert.status === 'ongoing' && (
                  <span className="resume-cert-status">Ongoing</span>
                )}
              </h3>
              <p className="resume-cert-meta">{cert.issuer}</p>
              {cert.url && (
                <a href={cert.url} target="_blank" rel="noreferrer" className="resume-cert-link">
                  {cert.url}
                </a>
              )}
            </div>
          ))}
        </div>
      ))}
    </ResumeSection>
  );
}
